import { render, staticRenderFns } from "./sub-order-list.vue?vue&type=template&id=1a423e2f&scoped=true"
import script from "./sub-order-list.vue?vue&type=script&lang=js"
export * from "./sub-order-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a423e2f",
  null
  
)

export default component.exports